<div class="asset-list-container" fxLayout="column" fxFill>
  <ng-container *ngIf="assetsLoaded; else loadingSkeletons">
    <div class="asset-list-title" fxLayout="row" fxLayoutAlign="start baseline">
      <h3 data-e2e-asset-list>{{listTitle}}</h3>
      <span *ngIf="assetCount > 0" class="count">{{assetCountResults | async}}</span>
      <app-asset-list-info></app-asset-list-info>
    </div>
    <div class="sorting-select" *ngIf="assetCount > 0" fxLayout="row" fxLayoutAlign="start center"
      fxLayoutGap="0.3rem">
      <mat-label class="sorting-select-label">{{ translateService.get(translations.appAssetList.sortingSelectLabel) | async | translate }}</mat-label>
      <mat-form-field appearance="none">
        <mat-select [formControl]="sortingControl" class="sorting-select-control">
          <mat-option *ngFor="let option of sortingOptions" [value]="option" class="sorting-select-option">
            {{option.viewValue}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="asset-list-scroll-container"
      role="listbox"
      [attr.aria-label]="listTitle"
      [attr.aria-activedescendant]="focusedAssetId ? 'asset-item-' + focusedAssetId : null"
      tabindex="0"
      infiniteScroll
      [infiniteScrollDisabled]="listUpdating"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="150"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
      (keydown)="onListKeydown($event)"
      (focus)="onListFocus()"
      (blur)="onListBlur()"
    >
      <app-asset-list-item 
        *ngFor="let asset of assets; trackBy:trackFn;"
        [id]="'asset-item-' + asset.assetId"
        role="option"
        [attr.aria-selected]="focusedAssetId === asset.assetId"
        [class.focused-visible]="listHasFocus && focusedAssetId === asset.assetId"
        [asset]="asset"
        (hoverOver)="hoverOver.emit(asset)"
        (hoverOut)="hoverOut.emit()" 
        (itemClick)="navigateToAsset($event.assetId)"
      >
      </app-asset-list-item>
      <p *ngIf="assetsLoaded && assets.length === 0" class="no-results-text">{{ translateService.get(translations.appAssetList.noResultsMsg) | async | translate }}</p>
    </div>
  </ng-container>
  <ng-template #loadingSkeletons>
    <div class='asset-list-scroll-container'>
      <div *ngFor='let i of [].constructor(skeletonMaxCount);'>
        <app-asset-list-item-skeleton></app-asset-list-item-skeleton>
      </div>
    </div>
  </ng-template>
</div>